import { ConditionValueSpecialistSet } from "./condition-value-specialist-set"

export const CONDITION_FIELDS = [
    // --- Original fields ---
    {
        value: "classification",
        label: "Task Classification",
        operators: ["is any of", "is none of"],
        valueComponent: "classification",
    },
    {
        value: "trade",
        label: "Trade",
        operators: ["is any of", "is none of"],
        valueComponent: "trade",
    },
    {
        value: "skill",
        label: "Skill",
        operators: ["is any of", "is none of"],
        valueComponent: "skill",
    },
    {
        value: "frequency",
        label: "Frequency",
        operators: ["more often than", "less often than", "exactly"],
        valueComponent: "frequency",
    },
    {
        value: "scheduleCode",
        label: "Schedule Code",
        operators: ["is any of", "is none of"],
        valueComponent: "scheduleCode",
    },

    // --- Task-level fields ---
    {
        value: "taskDuration",
        label: "Task Duration (minutes)",
        operators: ["greater than", "less than", "exactly", "between"],
        valueComponent: "numeric",
    },
    {
        value: "unitOfMeasure",
        label: "Unit of Measure",
        operators: ["is any of", "is none of"],
        valueComponent: "unitOfMeasure",
    },
    {
        value: "taskTitle",
        label: "Task Title",
        operators: ["contains", "starts with", "is any of"],
        valueComponent: "text",
    },
    {
        value: "taskOptionality",
        label: "Task Optionality",
        operators: ["is mandatory", "is optional"],
        valueComponent: "optionality",
    },

    // --- Schedule-level fields ---
    {
        value: "scheduleTitle",
        label: "Schedule Title",
        operators: ["contains", "starts with", "is any of", "is none of"],
        valueComponent: "text",
    },
    {
        value: "scheduleRetired",
        label: "Schedule Retired Status",
        operators: ["is retired", "is not retired"],
        valueComponent: "retired",
    },
    {
        value: "scheduleVersion",
        label: "Schedule Version",
        operators: ["equals", "greater than", "less than"],
        valueComponent: "numeric",
    },
    {
        value: "scheduleType",
        label: "Schedule Type",
        operators: ["is any of", "is none of"],
        valueComponent: "scheduleType",
    },
    {
        value: "scheduleLibraryFolder",
        label: "Schedule Library Folder",
        operators: ["is any of", "is none of"],
        valueComponent: "scheduleLibraryFolder",
    },
    {
        value: "specialistSet",
        label: "Specialist Sets",
        operators: ["is any of", "is none of"],
        component: ConditionValueSpecialistSet,
    },
    {
        value: "scheduleTags",
        label: "Schedule Tags",
        operators: ["has any of", "has none of", "has all of"],
        valueComponent: "scheduleTags",
    },

    // --- Compliance fields ---
    {
        value: "complianceItems",
        label: "Compliance Items",
        operators: ["has any of", "has none of", "has any"],
        valueComponent: "compliancePicker",
    },
    {
        value: "complianceType",
        label: "Compliance Type",
        operators: ["is any of", "is none of"],
        valueComponent: "complianceType",
    },
    {
        value: "hasCompliance",
        label: "Has Compliance",
        operators: ["is true", "is false"],
        valueComponent: "hasCompliance",
    },

    // --- Classification code fields ---
    {
        value: "nrmCode",
        label: "NRM Code",
        operators: ["starts with", "is any of", "is none of"],
        valueComponent: "codePicker",
    },
    {
        value: "uniclassCode",
        label: "Uniclass Code",
        operators: ["starts with", "is any of", "is none of"],
        valueComponent: "codePicker",
    },

    // --- Frequency period ---
    {
        value: "frequencyPeriod",
        label: "Frequency Period",
        operators: ["is any of"],
        valueComponent: "frequencyPeriod",
    },

    // --- Cost-aware fields ---
    {
        value: "hourlyRate",
        label: "Hourly Rate",
        operators: ["greater than", "less than", "between"],
        valueComponent: "numeric",
    },
    {
        value: "estimatedAnnualCost",
        label: "Estimated Annual Cost",
        operators: ["greater than", "less than", "between"],
        valueComponent: "numeric",
    },
    {
        value: "annualMinutes",
        label: "Annual Minutes",
        operators: ["greater than", "less than", "between"],
        valueComponent: "numeric",
    },

    // --- Regime-context-aware fields ---
    {
        value: "facilityName",
        label: "Facility Name (from Regime)",
        operators: ["is any of", "is none of"],
        valueComponent: "regimeOptions",
        regimeDataKey: "facilities",
    },
    {
        value: "town",
        label: "Town (from Regime)",
        operators: ["is any of", "is none of"],
        valueComponent: "regimeOptions",
        regimeDataKey: "towns",
    },
    {
        value: "postcode",
        label: "Postcode (from Regime)",
        operators: ["is any of", "is none of", "starts with"],
        valueComponent: "regimeOptions",
        regimeDataKey: "postcodes",
    },
    {
        value: "assetType",
        label: "Asset Type (from Regime)",
        operators: ["is any of", "is none of"],
        valueComponent: "regimeOptions",
        regimeDataKey: "assetTypes",
    },
    {
        value: "regimeField",
        label: "Regime Field",
        operators: ["is any of", "is none of"],
        valueComponent: "regimeField",
    },
    {
        value: "assetField",
        label: "Asset Register Field",
        operators: ["is any of", "is none of"],
        valueComponent: "assetField",
    },
]

export function getFieldConfig(fieldValue) {
    return CONDITION_FIELDS.find((f) => f.value === fieldValue) || null
}
